module.exports = __webpack_public_path__ + "static/media/slices_orange_arrow.784cf22b.svg";